'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Copyright;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _utils = require('shared/modules/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'copyright';

var getContent = function getContent() {
  var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (link.href) {
    return _react2.default.createElement(
      _reactRouter.Link,
      {
        to: link.href
      },
      link.label
    );
  }

  return link.label;
};

function Copyright(_ref) {
  var copyright = _ref.copyright;

  var year = new Date().getFullYear();

  var links = [{
    label: _react2.default.createElement(
      'span',
      null,
      '\xA9 Copyright ',
      year
    )
  }].concat(copyright);

  return _react2.default.createElement(
    'div',
    { className: CLASS_NAME },
    _react2.default.createElement(
      'div',
      { className: 'wrapper' },
      links.map(function (link, key) {
        var divider = key < links.length - 1 ? _react2.default.createElement(
          'div',
          { className: CLASS_NAME + '-divider', key: 'divider-' + key },
          '|'
        ) : null;

        var content = getContent(link);

        return _react2.default.createElement(
          'div',
          { className: CLASS_NAME + '-link', key: key },
          _react2.default.createElement(
            'span',
            null,
            content
          ),
          divider
        );
      }),
      _react2.default.createElement(
        'div',
        { className: 'footer-logos' },
        _react2.default.createElement('div', { className: 'footer-logo jp', onClick: (0, _utils.openUrl)('https://www.jpmorganchase.com/', '_blank') }),
        _react2.default.createElement('div', { className: 'footer-logo cuny', onClick: (0, _utils.openUrl)('http://www.cuny.edu/', '_blank') }),
        _react2.default.createElement('div', { className: 'footer-logo nycetc', onClick: (0, _utils.openUrl)('http://www.nycetc.org/', '_blank') }),
        _react2.default.createElement('div', { className: 'footer-logo cael', onClick: (0, _utils.openUrl)('https://www.cael.org/', '_blank') })
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/SiteFooter/Copyright.jsx
// module id = 1122
// module chunks = 0